export default {
  data () {
    return {}
  },
  methods: {
    getMealPeriodStartTime (mealPeriod = {}) {
      const startTime = mealPeriod.startTime?.split(':')
      if (!startTime) return undefined
      return parseInt(startTime[0] ?? '0') * 60 + parseInt(startTime[1] ?? 0)
    },
    getMealPeriodEndTime (mealPeriod = {}) {
      const endTime = mealPeriod.endTime?.split(':')
      if (!endTime) return undefined
      return parseInt(endTime[0] ?? '0') * 60 + parseInt(endTime[1] ?? 0)
    },
  }
}